import React, { useEffect, useRef } from 'react';

const Video = (props) => {
    const videoRef = useRef(null);
    const { video, ...attributes } = props;

    const handleVideoEnd = () => {
        const videoElement = videoRef.current;
        videoElement.pause();
        videoElement.currentTime = 0.44;
        videoElement.play();
    };

    useEffect(() => {
        const videoElement = videoRef.current;
        videoElement.addEventListener('ended', handleVideoEnd);

        return () => {
            videoElement.removeEventListener('ended', handleVideoEnd);
        };
    }, []);

    return (
        <video
            {...attributes}
            ref={videoRef}
            playsInline
            controls={false}
            controlsList="nofullscreen nodownload noplaybackrate noremoteplayback"
            disablePictureInPicture
            disableRemotePlayback
            webkit-playsinline="true"
            x5-playsinline="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="false"
        >
            <source src={video} type="video/mp4" />
        </video>
    );
};

export default Video;
